export enum CouponType {
  PERCENT = "PERCENT",
  VALUE = "VALUE"
}
